module.exports = __webpack_public_path__ + "static/media/md-git-branch.b88659c3.svg";